import api from './api';

export interface SavedMachine {
  id: string;
  modelloId: string;
  nome: string;
  marca: string;
  tipoMacchina: string;
  tipoMacchinaLabel: string;
  createdAt: string;
}

export interface ModelloAutocomplete {
  id: string;
  nome: string;
  marca: string;
  tipoMacchina: string;
  tipoMacchinaLabel: string;
}

/** Parco Macchine (Area Clienti) — collega la selezione modello al catalogo reale
 * (``abbinatore_modelli``) e persiste i modelli salvati per cliente sul backend. */
export const macchineService = {
  async list(): Promise<SavedMachine[]> {
    const { data } = await api.get<{ items: SavedMachine[] }>('/api/clienti/me/macchine');
    return data.items;
  },

  async add(modelloId: string): Promise<SavedMachine> {
    const { data } = await api.post<SavedMachine>('/api/clienti/me/macchine', { modelloId });
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/api/clienti/me/macchine/${id}`);
  },

  /** Ricerca modelli nel catalogo reale (stesso endpoint pubblico usato dalla ricerca in navbar). */
  async searchModelli(q: string): Promise<ModelloAutocomplete[]> {
    if (q.trim().length < 2) return [];
    const { data } = await api.get<{ results: ModelloAutocomplete[] }>('/api/abbinatore/autocomplete', {
      params: { q, limit: 20 },
    });
    return data.results;
  },
};
